import React, { useEffect } from 'react';
import { createReducer } from 'react-use';
import { searchHistoryStorage } from './QuickSearch/search-history-storage';
import { initialState, reducer } from './search-reducer';
import { usePersonalizationSettings } from '../../providers/DataProvider/DataContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchStateContext = /*#__PURE__*/React.createContext(undefined);
export const SearchDispatchContext = /*#__PURE__*/React.createContext(undefined);
export const SearchProvider = ({
  children
}) => {
  const {
    isActive
  } = usePersonalizationSettings();
  const storageMiddleware = store => next => action => {
    next(action);
    const state = store.getState();
    switch (action.type) {
      case 'add-search-entry':
        {
          searchHistoryStorage.set(state.searchHistory);
          break;
        }
      case 'clear-search-history':
        {
          searchHistoryStorage.reset();
          break;
        }
      default:
    }
  };
  const useCustomReducer = createReducer(storageMiddleware);
  const [state, dispatch] = useCustomReducer(reducer, {
    ...initialState,
    searchHistory: searchHistoryStorage.get()
  });
  useEffect(() => {
    if (!isActive) {
      dispatch({
        type: 'clear-search-history'
      });
    }
  }, [dispatch, isActive]);
  return /*#__PURE__*/_jsx(SearchStateContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(SearchDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
};
export const useSearchState = () => {
  const context = React.useContext(SearchStateContext);
  if (context === undefined) {
    throw new Error('useSearchState must be used within a SearchProvider');
  }
  return context;
};
export const useSearchDispatch = () => {
  const context = React.useContext(SearchDispatchContext);
  if (context === undefined) {
    throw new Error('useSearchDispatch must be used within a SearchProvider');
  }
  return context;
};